import React from 'react';
import AgentProfile from '@domain-group/fe-pa-allhomes-agent-profile';
import StandardPage from './common/standard-page.js';

/* eslint-disable react/jsx-filename-extension */

export default (props) => <StandardPage component={AgentProfile} {...props} />;
